import { render } from "./CourseView.vue?vue&type=template&id=6e394be6"
import script from "./CourseView.vue?vue&type=script&lang=js"
export * from "./CourseView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__